import { AppState } from '../../root-reducer';

export const selectBookmarkedMaps = (state: AppState) => state.bookmarkDomain.bookmarkedMaps;
export const selectBookmarkedMapsIsLoading = (state: AppState) => state.bookmarkDomain.bookmarkedMapsIsLoading;
